import {ReactNotificationOptions, store} from 'react-notifications-component';
import * as React from "react";

/**
 * Convenient adapter for the react-notification-component.
 */
class Notification {

  static success(opts: NotificationOptions) {
    store.addNotification({...Notification.DEFAULT_SUCCESS_OPTIONS, ...opts});
  }

  static error(opts: NotificationOptions) {
    store.addNotification({...Notification.DEFAULT_ERROR_OPTIONS, ...opts});
  }

  static warning(opts: NotificationOptions) {
    store.addNotification({...Notification.DEFAULT_WARNING_OPTIONS, ...opts});
  }

  private static readonly DEFAULT_OPTIONS: ReactNotificationOptions = {
    insert: 'top',
    container: 'bottom-right',
    animationIn: ['animated', 'fadeIn'],
    animationOut: ['animated', 'fadeOut'],
    dismiss: {
      duration: 5000,
      onScreen: true
    }
  };

  private static readonly DEFAULT_SUCCESS_OPTIONS: ReactNotificationOptions = {
    ...Notification.DEFAULT_OPTIONS,
    title: 'Success',
    message: '',
    type: 'success'
  };

  private static readonly DEFAULT_ERROR_OPTIONS: ReactNotificationOptions = {
    ...Notification.DEFAULT_OPTIONS,
    title: 'Error',
    message: '',
    type: 'danger'
  };

  private static readonly DEFAULT_WARNING_OPTIONS: ReactNotificationOptions = {
    ...Notification.DEFAULT_OPTIONS,
    title: 'Warning',
    message: '',
    type: 'warning',
  };
}

export interface NotificationOptions {
  title?: string | React.ReactNode | React.FunctionComponent;
  message: string | React.ReactNode | React.FunctionComponent;
  dismiss?: { duration: number, onScreen: boolean }
}

export default Notification;
